"use client";

import { FEATURE_FLAGS } from "@cede/types";
import { ExchangeIcon } from "@/components/icons";
import { useFeatureFlagValue } from "@/hooks/feature-flags";

export const CryptoComSignupHero = () => {
  const rewardAmount = useFeatureFlagValue(FEATURE_FLAGS.CRYPTOCOM_REFEREE_HUB_REWARD_AMOUNT, "50");

  return (
    <div className="flex flex-col items-center gap-4 animate-fade-in-up">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#1199FA]/10 border border-[#1199FA]/20">
        <ExchangeIcon exchange="cryptocom" size="xl" />
      </div>
      <h1 className="text-[32px] font-bold text-cede-text-primary text-center leading-tight">
        Sign Up on Crypto.com & Win <span className="text-cede-primary">${rewardAmount}</span>
      </h1>
      <p className="text-sm text-cede-text-secondary text-center max-w-[480px]">
        Complete each step to create your account and claim your reward
      </p>
    </div>
  );
};
